<template>
  <div
    class="products-shell app-shell"
    :style="{
      marginTop: headerHeight + 'px',
      minHeight: 'calc(100vh - ' + headerHeight + 'px)'
    }"
  >
    <div
      class="products-sidebar app-sidebar"
      :style="{ top: headerHeight + 'px' }"
    >
      <el-menu
        class="products-menu"
        :default-active="type"
        :default-openeds="[
          'grp-manufacturers',
          'grp-products',
          'grp-characterisation',
          'grp-model-generator'
        ]"
        background-color="transparent"
        @select="selectType"
      >
        <el-submenu
          v-if="p('Products.Manufacturers.View')"
          index="grp-manufacturers"
        >
          <template slot="title">
            <i class="el-icon-office-building"></i>
            <span>{{ $t('text.manufacturers') | firstLetterCapitalize }}</span>
          </template>
          <el-menu-item index="manufacturers">
            Manufacturer List
          </el-menu-item>
          <el-menu-item index="subscription">
            Subscription
          </el-menu-item>
        </el-submenu>

        <el-submenu
          v-if="
            p('Products.Product Description.View') ||
              p('Products.Product Characteristics.View')
          "
          index="grp-products"
        >
          <template slot="title">
            <i class="el-icon-goods"></i>
            <span>{{ $t('text.products') | firstLetterCapitalize }}</span>
          </template>
          <el-menu-item
            v-if="p('Products.Product Description.View')"
            index="product_description"
          >
            Product Description
          </el-menu-item>
          <el-menu-item
            v-if="p('Products.Product Description.View')"
            index="product_catalogue"
          >
            Product Catalogue
          </el-menu-item>
          <el-menu-item
            v-if="p('Products.Product Characteristics.View')"
            index="product_characteristics"
          >
            {{ $t('text.product_characteristics') }}
          </el-menu-item>
          <el-menu-item
            v-if="p('Products.Product Characteristics.View')"
            index="run_product_characteristics"
          >
            Run Product Characteristics
          </el-menu-item>
        </el-submenu>

        <el-submenu
          v-if="p('Products.Run.View') || p('Products.Analyse Runs.View')"
          index="grp-characterisation"
        >
          <template slot="title">
            <i class="el-icon-data-analysis"></i>
            <span>{{
              $t('text.characterisation') | firstLetterCapitalize
            }}</span>
          </template>
          <el-menu-item v-if="p('Products.Run.View')" index="run">
            {{ $t('text.run') | firstLetterCapitalize }}
          </el-menu-item>
          <el-menu-item
            v-if="p('Products.Analyse Runs.View')"
            index="analyse_runs"
          >
            {{ $t('text.analyse_runs') }}
          </el-menu-item>
        </el-submenu>

        <el-submenu
          v-if="p('Products.Model Generator.View')"
          index="grp-model-generator"
        >
          <template slot="title">
            <i class="el-icon-cpu"></i>
            <span>Model Generator</span>
          </template>
          <el-menu-item index="model_generator">
            Model Generator
          </el-menu-item>
        </el-submenu>
      </el-menu>
    </div>

    <div class="products-main app-main">
      <div class="products-page">
        <AppBreadcrumb
          root="Products"
          :current="typeTitle"
          @root-click="selectType(firstAvailableType)"
        >
          <UtcOffsets v-if="type === 'run' || type === 'analyse_runs'" />
          <el-button
            v-if="pageAction"
            type="primary"
            size="small"
            icon="el-icon-plus"
            @click="pageAction.onClick"
            >{{ pageAction.label }}</el-button
          >
        </AppBreadcrumb>

        <ManufacturerList v-if="type === 'manufacturers'" />
        <SubscriptionList v-if="type === 'subscription'" />
        <ProductList v-if="type === 'product_description'" />
        <ProductCatalogue v-if="type === 'product_catalogue'" />
        <ProductCharacteristics v-if="type === 'product_characteristics'" />
        <RunProductCharacteristics
          v-if="type === 'run_product_characteristics'"
        />
        <Run v-if="type === 'run'" />
        <AnalyseRuns v-if="type === 'analyse_runs'" />
        <ModelGenerator v-if="type === 'model_generator'" />
      </div>
    </div>
  </div>
</template>

<script>
import ManufacturerList from '@/components/products/manufacturers/ManufacturerList'
import SubscriptionList from '@/components/products/manufacturers/SubscriptionList'
import ProductList from '@/components/products/products/ProductList'
import ProductCatalogue from '@/components/products/products/ProductCatalogue'
import ProductCharacteristics from '@/components/products/products/ProductCharacteristics'
import RunProductCharacteristics from '@/components/products/products/RunProductCharacteristics'
import Run from '@/components/products/characterisation/Run'
import AnalyseRuns from '@/components/products/characterisation/AnalyseRuns'
import ModelGenerator from '@/views/ModelGenerator'
import headerHeight from '@/mixins/headerHeight'
import AppBreadcrumb from '@/components/AppBreadcrumb'
import UtcOffsets from '@/components/UtcOffsets'

const TYPE_TITLES = {
  manufacturers: 'Manufacturers',
  subscription: 'Subscription',
  product_description: 'Product Description',
  product_catalogue: 'Product Catalogue',
  product_characteristics: 'Product Characteristics',
  run_product_characteristics: 'Run Product Characteristics',
  run: 'Run',
  analyse_runs: 'Analyse Runs',
  model_generator: 'Model Generator'
}

export default {
  mixins: [headerHeight],
  data() {
    return {
      type: 'manufacturers',
      pageAction: null
    }
  },
  components: {
    ManufacturerList,
    SubscriptionList,
    ProductList,
    ProductCatalogue,
    ProductCharacteristics,
    RunProductCharacteristics,
    Run,
    AnalyseRuns,
    ModelGenerator,
    AppBreadcrumb,
    UtcOffsets
  },
  computed: {
    typeTitle() {
      return TYPE_TITLES[this.type] || ''
    },
    firstAvailableType() {
      if (this.$permission('Products.Manufacturers.View'))
        return 'manufacturers'
      if (this.$permission('Products.Product Description.View'))
        return 'product_description'
      if (this.$permission('Products.Product Characteristics.View'))
        return 'product_characteristics'
      if (this.$permission('Products.Run.View')) return 'run'
      if (this.$permission('Products.Analyse Runs.View')) return 'analyse_runs'
      return 'model_generator'
    }
  },
  mounted() {
    this.type = this.firstAvailableType
  },
  methods: {
    selectType(type) {
      this.type = type
      this.pageAction = null
    },
    setPageAction(action) {
      this.pageAction = action
    },
    clearPageAction() {
      this.pageAction = null
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/theme.scss';

.products-page {
  flex: 1;
  padding: 20px 24px;

  /deep/ .manage-content {
    margin-top: 0 !important;
  }

  /deep/ .page-title {
    display: none;
  }
}
</style>
